import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MojoFeatureExtensionsModule } from 'mojo-feature-extensions';

import { MaterialModule } from '@material/material.module';

import { AtsButtonComponent } from './ats-button.component';

@NgModule({
  declarations: [AtsButtonComponent],
  imports: [
    CommonModule,
    MojoFeatureExtensionsModule,
    MaterialModule,
  ],
  exports: [AtsButtonComponent],
})
export class AtsButtonModule {}
